import MessageList from "./MessageList";

export default function ChatContainer({ messages, typingMessage }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, padding: "8px 16px" }}>
      <div style={{ flex: 1 }}>
        <MessageList
          messages={messages}
          typingMessage={typingMessage}
        />
      </div>
    </div>
  );
}